import { render, staticRenderFns } from "./results.vue?vue&type=template&id=0efa730c&scoped=true"
import script from "./results.vue?vue&type=script&lang=js"
export * from "./results.vue?vue&type=script&lang=js"
import style0 from "./results.vue?vue&type=style&index=0&id=0efa730c&prod&lang=scss&scoped=true"
import style1 from "./results.vue?vue&type=style&index=1&id=0efa730c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efa730c",
  null
  
)

export default component.exports